import React, { useState } from 'react';

import { Dialog } from 'components/designSystem/Dialog';
import { TextFormField } from 'components/designSystem/inputs/TextField';
import { TertiaryButton } from 'components/designSystem/TertiaryButton';
import { PrimaryButton } from 'components/designSystem/PrimaryButton';
import { makeStyles } from '@material-ui/core';
// import { CheckCircle } from '@material-ui/icons';

import { Form } from 'react-final-form';
import { required } from 'lib/formValidators';
import { useDataProvider, useTranslate, useNotify } from 'ra-core';
import { publishAppSchema } from './PublishAppDialog.model';

const useStyles = makeStyles((theme) => ({
  bottomContainer: {
    display: 'flex',
    // alignItems: 'center',
    marginTop: theme.spacing(3),
    justifyContent: 'end',
    paddingBottom: theme.spacing(2),
    paddingTop: theme.spacing(2),
    alignItems: 'center',

    '& button': {
      padding: `${theme.spacing(1)}px ${theme.spacing(2)}px`,
      marginLeft: 16,
      fontSize: 14,
      fontWeight: theme.typography.fontWeightMedium,
    },
  },
  setDefaultContainer: {
    justifyContent: 'flex-end',
    position: 'relative',
    top: theme.spacing(3) * -1,
    left: theme.spacing(1) * -1,

    '& > div': {
      color: theme.palette.text.tertiary,
    },
  },
  form: {
    display: 'flex',
    flexDirection: 'column',
  },
  content: {
    paddingBottom: '16px',
    display: 'flex',
    flexDirection: 'column',
  },
}));

export const PublishAppDialog = ({ appId, isOpen, close, refresh }) => {
  const t = useTranslate();
  const classes = useStyles();
  const dataProvider = useDataProvider();
  const notify = useNotify();

  const [loading, setLoading] = useState(false);

  return (
    <Dialog isOpen={isOpen} close={loading ? () => {} : close} title={t('resources.apps.fields.titleVersion')}>
      <Form
        onSubmit={publishAppSchema(dataProvider, appId, setLoading, close, refresh, notify)}
        render={({ handleSubmit }) => (
          <form onSubmit={handleSubmit} className={classes.form}>
            <div className={classes.content}>
              <TextFormField
                name="versionName"
                full
                dense
                size="full"
                label={t('resources.apps.fields.versionApp')}
                placeholder={t('resources.apps.fields.placeholderVersion')}
              />
            </div>
            <TextFormField
              name="versionComment"
              validate={required(t)}
              full
              dense
              size="full"
              label={t('resources.apps.fields.commentVersion')}
              placeholder={t('resources.apps.fields.placeholderCommentary')}
              required
              iconPosition="right"
            />

            <div className={classes.bottomContainer}>
              <TertiaryButton disabled={loading} label={t('actionButtons.cancel')} onClick={close} />
              <PrimaryButton
                disabled={loading}
                type="submit"
                label={t('actionButtons.create')}
                onClick={handleSubmit}
                // icon={<CheckCircle />}
              />
            </div>
          </form>
        )}
      />
    </Dialog>
  );
};
